import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";

function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }

import { ExtensionMessage } from './models/extensionMessage.js';
import { ExtensionMessageType } from "./models/extensionMessageType.js";
import { RestClient } from './restClient.js';
export var Extensions = /*#__PURE__*/function () {
  function Extensions(shop, basketId, imagineEnvironmentBaseUrl) {
    var authToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    var getNewAuthTokenFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    var customRequestHeaders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

    _classCallCheck(this, Extensions);

    this.shop = shop;
    this.basketId = basketId;
    this.messageChannels = [];
    this.shop = shop;
    this.basketId = basketId;
    this.client = new RestClient(imagineEnvironmentBaseUrl, shop, authToken, getNewAuthTokenFunction, customRequestHeaders);
  }

  _createClass(Extensions, [{
    key: "invokeExtensions",
    value: function () {
      var _invokeExtensions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(extensionSubscriptions, iframe) {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, extensionSubscription;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (iframe) {
                  _context.next = 3;
                  break;
                }

                throw new Error('No valid iframe provided!');

              case 3:
                if (!extensionSubscriptions) {
                  _context.next = 33;
                  break;
                }

                // See https://2ality.com/2016/10/asynchronous-iteration.html for docs on 'for-await-of'
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context.prev = 6;
                _iterator = _asyncIterator(extensionSubscriptions);

              case 8:
                _context.next = 10;
                return _iterator.next();

              case 10:
                if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                  _context.next = 17;
                  break;
                }

                extensionSubscription = _step.value;
                _context.next = 14;
                return this.invokeExtension(extensionSubscription, iframe);

              case 14:
                _iteratorAbruptCompletion = false;
                _context.next = 8;
                break;

              case 17:
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](6);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 23:
                _context.prev = 23;
                _context.prev = 24;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context.next = 28;
                  break;
                }

                _context.next = 28;
                return _iterator.return();

              case 28:
                _context.prev = 28;

                if (!_didIteratorError) {
                  _context.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context.finish(28);

              case 32:
                return _context.finish(23);

              case 33:
                _context.next = 38;
                break;

              case 35:
                _context.prev = 35;
                _context.t1 = _context["catch"](0);
                console.error(_context.t1.message, _context.t1);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 35], [6, 19, 23, 33], [24,, 28, 32]]);
      }));

      function invokeExtensions(_x, _x2) {
        return _invokeExtensions.apply(this, arguments);
      }

      return invokeExtensions;
    }()
  }, {
    key: "triggerEvent",
    value: function triggerEvent(eventId) {
      return this.getExtensionSubscriptionByEvent(eventId);
    }
  }, {
    key: "disposeMessageListeners",
    value: function disposeMessageListeners() {
      if (this.messageChannels && this.messageChannels.length > 0) {
        this.messageChannels.forEach(function (messageChannel) {
          messageChannel.port1.close();
          messageChannel.port2.close();
        });
      }
    }
  }, {
    key: "getExtensionSubscriptionByEvent",
    value: function () {
      var _getExtensionSubscriptionByEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(eventId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.client.get("extension/extensionSubscriptions/".concat(eventId));

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                console.error('Failed to get extension subscriptions by event', _context2.t0);
                return _context2.abrupt("return", new Promise(function (resolve) {
                  return resolve([]);
                }));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function getExtensionSubscriptionByEvent(_x3) {
        return _getExtensionSubscriptionByEvent.apply(this, arguments);
      }

      return getExtensionSubscriptionByEvent;
    }()
  }, {
    key: "putExtensionDataEntry",
    value: function () {
      var _putExtensionDataEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(extensionDataEntry) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.client.put('extension/extensionDataEntry', extensionDataEntry);

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                console.error('Failed to put extension data entry', _context3.t0);
                return _context3.abrupt("return", new Promise(function (resolve) {
                  return resolve(null);
                }));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 6]]);
      }));

      function putExtensionDataEntry(_x4) {
        return _putExtensionDataEntry.apply(this, arguments);
      }

      return putExtensionDataEntry;
    }()
  }, {
    key: "getExtension",
    value: function getExtension(extensionSubscriptionId) {
      return this.client.get("extension/".concat(extensionSubscriptionId, "/").concat(this.basketId));
    }
  }, {
    key: "invokeExtension",
    value: function () {
      var _invokeExtension = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(extensionSubscription, iframe) {
        var _this = this;

        var extension, messageChannel, extensionRunningPromise;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.getExtension(extensionSubscription.id);

              case 3:
                extension = _context4.sent;
                messageChannel = new MessageChannel();
                extensionRunningPromise = new Promise(function (resolve) {
                  _this.messageChannels.push(messageChannel);

                  messageChannel.port1.onmessage = function (event) {
                    _this.onMessageReceived(event.data, extension, resolve);
                  };
                });
                iframe.addEventListener('load', function initiateHandshake() {
                  var _a;

                  var handshakeMessage = new ExtensionMessage(ExtensionMessageType.Handshake, extension.encryptedExtension);
                  var targetOrigin = new URL(extension.url).origin;
                  (_a = this.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(handshakeMessage, targetOrigin, [messageChannel.port2]);
                }, {
                  once: true
                });
                iframe.src = extension === null || extension === void 0 ? void 0 : extension.url;
                iframe.title = extension === null || extension === void 0 ? void 0 : extension.name;
                return _context4.abrupt("return", extensionRunningPromise);

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](0);
                console.error('Failed to invoke extension', _context4.t0);
                return _context4.abrupt("return", new Promise(function (resolve) {
                  return resolve();
                }));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 12]]);
      }));

      function invokeExtension(_x5, _x6) {
        return _invokeExtension.apply(this, arguments);
      }

      return invokeExtension;
    }()
  }, {
    key: "onMessageReceived",
    value: function onMessageReceived(message, extension, resolve) {
      try {
        switch (message.type) {
          case ExtensionMessageType.ExecutionComplete:
            this.extensionExecutionComplete(extension, message.encryptedPayload, resolve);
            break;

          default:
            throw new Error("Unsupported message type ".concat(message.type, " received!"));
        }
      } catch (e) {
        console.error(e.message, e);
        this.disposeMessageListeners();
      }
    }
  }, {
    key: "extensionExecutionComplete",
    value: function () {
      var _extensionExecutionComplete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(extension, encryptedPayload, resolve) {
        var extensionDataEntry;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                extensionDataEntry = {
                  basketId: this.basketId,
                  extensionId: extension.id,
                  eventId: extension.eventId,
                  moduleAuthId: extension.moduleAuthId,
                  shop: this.shop,
                  encryptedData: encryptedPayload
                };
                _context5.next = 3;
                return this.putExtensionDataEntry(extensionDataEntry);

              case 3:
                this.disposeMessageListeners();
                resolve();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function extensionExecutionComplete(_x7, _x8, _x9) {
        return _extensionExecutionComplete.apply(this, arguments);
      }

      return extensionExecutionComplete;
    }()
  }]);

  return Extensions;
}();